
import React from 'react';
 
const Contact = () => {
    return (
        <div id="about-wrapper">
            <div id="about">
                <h1>
                    Contact Me
                </h1>
                <h3 style={{textAlign: "center"}}>
                    Feel free to contact me about any business inquiries through
                     whatever channel brought you to the website.
                </h3>
            </div>
        </div>
    );
};
 
export default Contact;
